import { authorize } from "store/features/authorization/authorization.actions";
import { put } from "redux-saga/effects";
import { buildAuthorizationModel } from "api/factories/authorization.factory";
import decodeJwt from "jwt-decode";
import { getLocalStorageAccessToken, setLocalStorageAccessToken } from "utils";
import { JsonWebToken } from "api";

const authorizationFailure = () => {
    return put(authorize.failure({ statusCode: 401 }));
};

export function* authorizationSagas(jwtToken: string | null): Generator {
    const token = jwtToken || getLocalStorageAccessToken();

    if (!token) {
        return yield authorizationFailure();
    }

    try {
        const decoded = decodeJwt(`${token}`) as JsonWebToken;
        setLocalStorageAccessToken(token);
        yield put(authorize.success(buildAuthorizationModel({ ...decoded.info, token })));
    } catch (err) {
        return yield authorizationFailure();
    }
}
